import $ from 'jquery';
import tippy from 'tippy.js';
import moment from 'moment/moment';
import View from 'mixins/view';
import MustacheComponent from '@components/mustache-component';

export const elements = {
    template: '#mustache-moderator-ban',
    container: '.delete-modal',
    submit: '.c-comments-moderation__buttons button',
    cancel: '.ban-cancel',
    period: '.ban__period',
    reason: '.ban__reason',
    message: '.additional-msg textarea',
    error: '.form-error',
    undelete: '.f-isDeletedContainer',
};

export default class BanModal extends View {
    constructor(model) {
        super(model);
        this.instance = null;
        this.setRootEl($('<div class="delete-modal text-align_left">'));
    }
    events() {
        const $submit = this.getRootEl().find(elements.submit);
        const $cancel = this.getRootEl().find(elements.cancel);
        const $reason = this.getRootEl().find(elements.reason);
        const $period = this.getRootEl().find(elements.period);
        const $undelete = this.getRootEl().find(elements.undelete);

        const validate = () => {
            const isReasonSet = () => {
                const checked = $reason.find('.fn-active input');
                let isSet = !!checked.length;
                const explanation = $reason.find('input[type="text"]').val();

                if (checked.attr('id') === 'ffcustomReason' && !explanation.length) {
                    isSet = false;
                }
                return isSet;
            };
            const periodIsSet = $period.find('.custom-radio input:checked').length;
            const reasonIsSet = isReasonSet();

            return periodIsSet && reasonIsSet;
        };

        const handleBanClick = (event) => {
            event.preventDefault();
            event.stopPropagation();

            const $error = this.getRootEl().find(elements.error);
            if (!validate()) {
                $error.removeClass('fn-hidden');
            } else {
                $error.addClass('fn-hidden');
                const description = $reason.find("input[type='text']").val();
                const message = this.getRootEl().find(elements.message).val();

                const request = {
                    CommentId: this.getModel().get('id'),
                    period: $period.find('.custom-radio.fn-active input')
                    .attr('id').substr(2),
                    reason: $reason.find('.custom-radio.fn-active input')
                    .attr('id').substr(2),
                };

                if (description && request.reason === 'customReason') {
                    request.reason = description;
                }
                if (message) {
                    request.messageToUser = message;
                }

                document.dispatchEvent(new CustomEvent('AddBan', {
                    detail: request,
                }));
                this.destroy();
            }
        };
        $submit.off().on('click', handleBanClick);

        const model = this.getModel();
        const ban = model.get('banInfo');
        if (ban) {
            const handleCancelBanClick = (event) => {
                event.preventDefault();
                event.stopPropagation();

                document.dispatchEvent(new CustomEvent('CancelBan', {
                    detail: {
                        url: ban.cancelUrl,
                        id: model.get('id'),
                    },
                }));
                this.destroy();
            };
            $cancel.off().on('click', handleCancelBanClick);
        }

        const isDeleted = model.get('isDeleted');
        if (isDeleted) {
            const handleUndeleteClick = (event) => {
                event.preventDefault();
                event.stopPropagation();

                document.dispatchEvent(
                    new CustomEvent('DeleteComment', {
                        detail: {
                            id: model.get('id'),
                            isDeleted,
                        },
                    })
                );
                this.destroy();
            };
            $undelete.off().on('click', handleUndeleteClick);
        }
    }
    destroy() {
        if (this.instance) {
            this.instance.hide();
        }
    }
    init(target) {
        if (this.instance || !this.getRootEl().length) {
            return false;
        }
        this.render();
        const content = this.getRootEl().get(0);

        this.instance = tippy(target, {
            flip: false,
            interactive: true,
            content,
            delay: [200, 0],
            arrow: true,
            placement: 'bottom',
            arrowType: 'round',
            size: 'large',
            duration: [200, 100],
            animation: 'shift-away',
            hideOnClick: false,
        });
        return true;
    }
    render() {
        const model = this.getModel();
        const ban = model.get('banInfo');

        const prepare = () => {
            if (ban) {
                const exists = Boolean(ban);
                const link = (exists && ban.commentUrl) ? ban.commentUrl : false;
                const cancelled = exists ? Boolean(!ban.isActive) : false;
                const ends = moment(ban.endsAt).fromNow();
                const isDeleted = model.get('isDeleted');

                return {
                    exists,
                    isDeleted,
                    ban,
                    link,
                    cancelled,
                    ends,
                };
            }
            return {};
        };

        const apply = () => {
            if (ban) {
                const $root = this.getRootEl();
                const getReason = () => {
                    if (ban.reason === 'hate' || ban.reason === 'spam') {
                        return $root.find(`label[for='ff${ban.reason}']`).html();
                    }
                    return ban.reason;
                };
                const period = $root.find(`label[for="ff${ban.period}"]`).html();
                const reason = getReason();

                $root.find(`label[for='${ban.period}']`).html(period);
                $root.find(`label[for='${ban.reason}']`).html(reason);
            }
        };

        const data = prepare();
        const mustache = new MustacheComponent($(elements.template));
        mustache.set(data);

        const html = mustache.render();
        this.getRootEl().html(html);

        apply();
        this.events();
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/ban-modal.js